<p-scrollPanel [style]="{width: '100%', height: '60vh'}">
  <form #f="ngForm" (ngSubmit)="onSubmit()">
    <div class="container-fluid">
      <!-- <div class="login-spiner" *ngIf="show_spin" aria-hidden="true">
        <div class="nb-spinner" role="status">
          <span class="sr-only">...</span>
        </div>
      </div> -->
      <div class="row">
        <div class="col-12">
          <div role="alert" class="alert alert-info">
            <i aria-hidden="true" class="fas fa-1-5x fa-info-circle m-r-md"></i>
            Introduzca el PIN del certificado seleccionado
          </div>
        </div>
        <div class="col-12">
          <formElement [model]="this" [fieldConfig]="getPINConfig()"></formElement>
        </div>
      </div>
      <div class="row m-t-md justify-content-center">
        <button tabindex="2" type="submit" class="btn btn-primary block m-b btn-lg" [disabled]="!pin">
          {{ 'General.accept' | translate }}
        </button>
      </div>
    </div>
  </form>
</p-scrollPanel>